import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService"
import FeatureFlagService from "./FeatureFlagService";

export default class OverviewService extends AbstractService {
	static endpoint = ENDPOINTS.dashboard;

	static dashboardsApi = NexusService.dashboardsApi;

	static getOverviewData(queryParams, user) {
		if (FeatureFlagService.isEnabled('use_api_core_endpoints_dashboards') && user != null) {
			const getReq = {};

			if (Object.hasOwn(queryParams, 'dateRange')) {
				getReq.dateRange = queryParams.dateRange;
			}

			if (user.isCoordinator() && user.IsRKPay) {
				return this.dashboardsApi.getCoordinatorDashboard(getReq)
					.then((response) => ({ data: response }));
			}

			if (user.isLEA() && user.IsStaffAdmin) {
				return this.dashboardsApi.getLeaDashboard()
					.then((response) => ({ data: response }));
			}
		}

		return this.get({
			endpoint: this.endpoint,
			queryParams,
		});
	}
}
